// Modern ES6+ imports
console.log('📁 Phone');

// Phone Number Selector Class
class PhoneNumberSelector {
    constructor(container) {
        this.container = container;
        this.countrySelector = container.querySelector('.country-selector, .wpcf7-select');
        this.codeDisplay = container.querySelector('.country-code-display, div:not([class])');
        this.phoneInput = container.querySelector('.phone-input, input[type="phone"], input[name="phone"]');
        this.hiddenInput = container.querySelector('.full-phone-value');
        this.isValidPhone = false;
        
        this.init();
    }
    
    init() {
        this.setupHiddenInput();
        this.bindEvents();
        this.setInitialValues();
        this.updatePhoneFormat();
    }

    setupHiddenInput() {
        if (!this.hiddenInput) {
            this.hiddenInput = document.createElement('input');
            this.hiddenInput.type = 'hidden';
            this.hiddenInput.name = 'full_phone';
            this.hiddenInput.className = 'full-phone-value';
            this.container.appendChild(this.hiddenInput);
        }
    }
    
    bindEvents() {
        this.countrySelector?.addEventListener('change', (e) => {
            this.handleCountryChange(e);
        });
        
        this.phoneInput?.addEventListener('input', (e) => {
            this.handlePhoneInput(e);
        });
        
        this.phoneInput?.addEventListener('keyup', (e) => {
            this.formatPhoneNumber(e);
        });
        
        this.phoneInput?.addEventListener('blur', (e) => {
            this.validatePhone(e);
        });

        this.phoneInput?.addEventListener('paste', (e) => {
            setTimeout(() => {
                this.formatPhoneNumber(e);
                this.validatePhone(e);
            }, 10);
        });

        this.phoneInput?.addEventListener('focus', (e) => {
            this.hideError();
        });
    }
    
    handleCountryChange(e) {
        const selectedOption = e.target.selectedOptions[0];
        const countryCode = selectedOption.getAttribute('data-code') || this.getCountryCode(selectedOption.value);
        const countryValue = selectedOption.value;
        
        if (this.codeDisplay) {
            this.codeDisplay.textContent = countryCode;
        }
        
        this.phoneInput?.setAttribute('data-country', countryValue);
        this.updatePlaceholder(countryValue);
        
        if (this.phoneInput) {
            this.phoneInput.value = '';
            this.phoneInput.focus();
        }
        
        this.updateHiddenInput();
        console.log(`🌍 Country changed to: ${countryValue} (${countryCode})`);
    }

    getCountryCode(countryValue) {
        const countryCodes = {
            'id': '+62',
            'ar': '+54', 
            'us': '+1',
            'gb': '+44',
            'uk': '+44',
            'my': '+60',
            'sg': '+65',
            'th': '+66',
            'vn': '+84',
            'ph': '+63',
            'au': '+61'
        };
        return countryCodes[countryValue] || '+62';
    }
    
    handlePhoneInput(e) {
        let value = e.target.value.replace(/[^\d\s-()]/g, '');
        e.target.value = value;
        this.updateHiddenInput();
    }
    
    formatPhoneNumber(e) {
        const country = this.phoneInput?.getAttribute('data-country') || 'id';
        let value = e.target.value.replace(/[^\d]/g, '');
        
        switch(country) {
            case 'id':
                value = this.formatIndonesian(value);
                break;
            case 'us':
                value = this.formatUS(value);
                break;
            case 'gb':
            case 'uk':
                value = this.formatUK(value);
                break;
            case 'ar':
                value = this.formatArgentina(value);
                break;
            default:
                value = this.formatDefault(value);
        }
        
        e.target.value = value;
        this.updateHiddenInput();
    }
    
    formatIndonesian(value) {
        if (value.length <= 3) return value;
        if (value.length <= 7) return `${value.slice(0, 3)}-${value.slice(3)}`;
        if (value.length <= 11) return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
        return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
    }
    
    formatUS(value) {
        if (value.length <= 3) return value;
        if (value.length <= 6) return `(${value.slice(0, 3)}) ${value.slice(3)}`;
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
    
    formatUK(value) {
        if (value.length <= 4) return value;
        if (value.length <= 7) return `${value.slice(0, 4)} ${value.slice(4)}`;
        return `${value.slice(0, 4)} ${value.slice(4, 7)} ${value.slice(7, 11)}`;
    }
    
    formatArgentina(value) {
        if (value.length <= 2) return value;
        if (value.length <= 6) return `${value.slice(0, 2)}-${value.slice(2)}`;
        return `${value.slice(0, 2)}-${value.slice(2, 6)}-${value.slice(6, 10)}`;
    }
    
    formatDefault(value) {
        if (value.length <= 3) return value;
        if (value.length <= 6) return `${value.slice(0, 3)}-${value.slice(3)}`;
        return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
    
    updatePlaceholder(country) {
        if (!this.phoneInput) return;
        
        const placeholders = {
            'id': 'XXX-XXXX-XXXX',
            'us': '(XXX) XXX-XXXX',
            'gb': 'XXXX XXX XXXX',
            'uk': 'XXXX XXX XXXX',
            'ar': 'XX-XXXX-XXXX',
            'my': 'XX-XXX-XXXX',
            'sg': 'XXXX-XXXX',
            'th': 'XX-XXX-XXXX',
            'vn': 'XXX-XXX-XXXX',
            'ph': 'XXX-XXX-XXXX',
            'au': 'XXXX-XXX-XXX'
        };
        
        this.phoneInput.placeholder = placeholders[country] || 'XXX-XXX-XXXX';
    }
    
    updateHiddenInput() {
        if (!this.hiddenInput || !this.codeDisplay || !this.phoneInput) return;
        
        const countryCode = this.codeDisplay.textContent || '+62';
        const phoneNumber = this.phoneInput.value.replace(/[^\d]/g, '');
        const fullPhone = phoneNumber ? `${countryCode}${phoneNumber}` : '';
        
        this.hiddenInput.value = fullPhone;
    }
    
    validatePhone(e) {
        const country = this.phoneInput?.getAttribute('data-country') || 'id';
        const phoneNumber = e.target.value.replace(/[^\d]/g, '');
        
        const minLengths = {
            'id': 9, 'us': 10, 'gb': 10, 'uk': 10, 'ar': 8,
            'my': 8, 'sg': 8, 'th': 8, 'vn': 8, 'ph': 10, 'au': 9
        };
        
        const minLength = minLengths[country] || 8;
        
        if (phoneNumber.length < minLength) {
            this.isValidPhone = false;
            e.target.classList.add('invalid');
            this.showError(`Phone number must be at least ${minLength} digits`);
        } else {
            this.isValidPhone = true;
            e.target.classList.remove('invalid');
            this.hideError();
        }

        return this.isValidPhone;
    }
    
    showError(message) {
        let errorDiv = this.container.querySelector('.phone-error');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'phone-error';
            errorDiv.style.cssText = 'color: #d32f2f; font-size: 12px; margin-top: 5px;';
            this.container.appendChild(errorDiv);
        }
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
    }
    
    hideError() {
        const errorDiv = this.container.querySelector('.phone-error');
        if (errorDiv) {
            errorDiv.style.display = 'none';
        }
    }
    
    setInitialValues() {
        if (this.countrySelector && this.codeDisplay) {
            const selectedOption = this.countrySelector.selectedOptions[0];
            const countryCode = selectedOption?.getAttribute('data-code') || this.getCountryCode(selectedOption?.value || 'id');
            this.codeDisplay.textContent = countryCode;
        }
        
        if (this.phoneInput) {
            const country = this.countrySelector?.value || 'id';
            this.updatePlaceholder(country);
            this.phoneInput.setAttribute('data-country', country);
        }
    }

    updatePhoneFormat() {
        if (this.phoneInput?.value) {
            this.formatPhoneNumber({ target: this.phoneInput });
        }
    }
    
    getFullPhoneNumber() {
        return this.hiddenInput?.value || '';
    }

    isValid() {
        return this.isValidPhone;
    }

    reset() {
        if (this.phoneInput) {
            this.phoneInput.value = '';
            this.phoneInput.classList.remove('invalid');
        }
        if (this.hiddenInput) {
            this.hiddenInput.value = '';
        }
        this.hideError();
        this.isValidPhone = false;
    }

    setPhoneNumber(fullPhone) {
        if (this.phoneInput && fullPhone) {
            const match = fullPhone.match(/^(\+\d{1,4})(.+)$/);
            if (match) {
                const [, code, number] = match;
                if (this.codeDisplay) {
                    this.codeDisplay.textContent = code;
                }
                this.phoneInput.value = number;
                this.formatPhoneNumber({ target: this.phoneInput });
            }
        }
    }
}

// Your main app
class Phonenumber {
    constructor() {
        this.containers = [];
        this.init();
    }

    init() {
        this.phone();
    }

    phone() {
        const phoneContainers = document.querySelectorAll('.specialPhoneNumber');
        
        phoneContainers.forEach(container => {
            const phoneInstance = new PhoneNumberSelector(container);
            this.containers.push(phoneInstance);
        });

        console.log(`📞 Initialized ${phoneContainers.length} phone number inputs`);
    }

    getAllPhoneNumbers() {
        return this.containers.map(container => container.getFullPhoneNumber());
    }

    validateAll() {
        return this.containers.every(container => container.isValid());
    }

    resetAll() {
        this.containers.forEach(container => container.reset());
    }
}

// ✅ TAMBAHKAN EXPORT INI - PENTING!
export { Phonenumber };

// Keep global access for compatibility
if (typeof window !== 'undefined') {
    window.Phonenumber = Phonenumber;
}